export enum StorageKey {
  privacyAgreementAccepted = 'privacy-agreement-accepted',
  languageCode = 'language-code',
}

export enum LanguageCode {
  EN_LNG_CODE = 'en',
  ES_LNG_CODE = 'es',
}

export const EN = 'English';
export const ES = 'Español';
